export { default } from './language-panel'
